import { getHrefUrl } from "./../url/get-href-url";
const getLinkHrefUrl = (link, baseUrl) => typeof link.url === "string" ? getHrefUrl(link.url, baseUrl) : typeof link.anchor === "string" ? `#viewer-${link.anchor}` : void 0;
export {
  getLinkHrefUrl
};
//# sourceMappingURL=get-link-href-url.js.map
